import { HttpClientModule } from '@angular/common/http';
// import * as momentImported from 'moment';
// const moment = (momentImported as any).default || momentImported;
import { AppComponent } from './app.component';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './modules/shared/shared.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
// import { Directive, ElementRef, Input, Renderer } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { StorageService } from './modules/shared/services/storage.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderService } from './modules/shared/components/loader/loader.service';
// import { TranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';

import { EditorModule } from 'primeng/editor';
import { PanelModule } from 'primeng/panel';
// import { GrowlModule } from 'primeng/growl';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NotificationsService } from './modules/shared/services/notifications.service';
import { TrackMyLocationComponent } from './pages/track-my-location/track-my-location.component';
import { LoginComponent } from './pages/login/login.component';
import { PasswordModule } from 'primeng/password';
import { MessageService } from 'primeng/api';
import { PaymentStripComponent } from './modules/payment-strip/payment-strip.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { CommonBindingDataService } from './modules/shared/services/common-binding-data.service';
import { ExportUserDetailsComponent } from './pages/export-user-details/export-user-details.component';
import { SupportComponent } from './pages/support/support.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.components';

@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    SignInComponent,
    TermsConditionsComponent,
    TrackMyLocationComponent,
    LoginComponent,
    PaymentStripComponent,
    PrivacyPolicyComponent,
    ExportUserDetailsComponent,
    SupportComponent,
    ResetPasswordComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PanelModule,
    InputTextModule,
    EditorModule,
    DialogModule,
    ButtonModule,
//     GrowlModule,
    MultiSelectModule,
    AppRoutingModule,
    FieldsetModule,
    OverlayPanelModule,
    CalendarModule,
    FileUploadModule,
    ConfirmDialogModule,
    ToastModule,
    PasswordModule,
    SharedModule.forRoot()
  ],
  providers: [StorageService, ConfirmationService, LoaderService, NotificationsService, MessageService],
  bootstrap: [AppComponent]
})
export class AppModule {
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule
    };
  }
  constructor(private title: Title,
    private commonBindingDataService: CommonBindingDataService) {
    this.title.setTitle(this.commonBindingDataService.getLabel('title_common'));
  }
}
